import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";
import { useI18n } from "../i18n";
import { toast } from "sonner";
import { Trophy } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", name: "", username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await register(form);
    setLoading(false);
    if (res.ok) {
      toast.success(t("welcome_toast"));
      nav("/matches");
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md border border-white/10 bg-[#0d0d0d] p-8 fade-up">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-6 h-6 flex items-center justify-center bg-[#00D37F] text-black">
            <Trophy className="w-3.5 h-3.5" strokeWidth={2.5} />
          </div>
          <span className="text-[11px] uppercase tracking-[0.3em] font-mono font-bold text-[#00D37F]">
            POLLAGOL 2026
          </span>
        </div>
        <h1 className="font-display text-5xl sm:text-6xl">{t("create_account")}</h1>
        <p className="text-sm text-white/50 mt-2 font-mono uppercase tracking-wider">
          {t("register")}
        </p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4" data-testid="register-form">
          {[
            { key: "name", label: t("name"), type: "text", auto: "name" },
            { key: "username", label: t("username"), type: "text", auto: "username" },
            { key: "email", label: t("email"), type: "email", auto: "email" },
            { key: "password", label: t("password"), type: "password", auto: "new-password" },
          ].map((f) => (
            <div key={f.key}>
              <label className="text-[10px] uppercase tracking-[0.3em] text-white/60 font-mono font-bold">
                {f.label}
              </label>
              <input
                type={f.type}
                value={form[f.key]}
                onChange={upd(f.key)}
                required
                autoComplete={f.auto}
                data-testid={`register-${f.key}`}
                className="w-full mt-2 h-12 px-3 bg-black border border-white/20 focus:border-[#00D37F] focus:outline-none focus:ring-1 focus:ring-[#00D37F] text-white text-sm"
              />
            </div>
          ))}
          {error && (
            <div
              data-testid="register-error"
              className="text-xs text-[#FF2D45] border border-[#FF2D45]/30 bg-[#FF2D45]/10 px-3 py-2 font-mono"
            >
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            data-testid="register-submit"
            className="w-full h-13 py-3.5 bg-[#00D37F] hover:bg-[#00E78B] text-black font-head text-base transition-colors disabled:opacity-50"
          >
            {loading ? "…" : t("register")}
          </button>
        </form>

        <p className="mt-6 text-xs text-white/50 font-mono">
          {t("have_account")}{" "}
          <Link to="/login" className="text-[#00D37F] hover:underline font-bold" data-testid="to-login">
            {t("login")}
          </Link>
        </p>
      </div>
    </div>
  );
}
